// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"f0899748","116":"f0899748","243":"29fe80cd","2216":"f0899748","3884":"8779873e","5077":"f0899748","5906":"58f44b7a","8382":"cfaa1461","8670":"180155fc"}[chunkId] + ".chunk.css";
};